

import { t } from '../i18n';
import React, { useState, useEffect } from 'react';

// Utility to get API base URL depending on environment
const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  // Use relative URL for production
  return '';
};

const NewsletterSubscription = ({ isLoggedIn, token, customStyles, customButtonStyles }) => {
  const [email, setEmail] = useState(''); // Initialize email as empty
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Only fetch if logged in and token exists
    if (!isLoggedIn || !token) {
      setEmail('');
      return;
    }
    fetch(`${getApiBaseUrl()}/api/me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((response) => {
        if (response.status === 401) {
          // Token invalid, do not set email
          return null;
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.email) {
          setEmail(data.email);
        }
      })
      .catch((error) => {
        console.error('Error fetching user email:', error);
      });
  }, [isLoggedIn, token]);

  const handleSubscribe = () => {
    if (!email) {
      setMessage('Saisissez un email pour vous abonner.');
      return;
    }

    fetch(`${getApiBaseUrl()}/api/newsletter/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        isLoggedIn,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setMessage(data.message);
          setEmail(isLoggedIn ? email : ''); // Reset email input for non-logged-in users
        } else {
          setMessage(data.error || 'Failed to subscribe.');
        }
      })
      .catch((error) => {
        console.error('Error subscribing to newsletter:', error);
        setMessage('An error occurred. Please try again.');
      });
  };

  return (
    <div style={{ ...styles.container, ...customStyles }}> {/* Merge default and custom styles */}
      <h3>{t('newsletterTitle') || 'Rejoignez la newsletter des sauveteurs !'}</h3>
      <input
        type="email"
        placeholder={t('newsletterPlaceholder') || 'Votre mail de secouriste'}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.emailInput}
      />
      <button
        onClick={handleSubscribe}
        style={{ ...styles.subscribeButton, ...customButtonStyles }} // Merge default and custom button styles
      >
        {t('newsletterButton') || "S'engager"}
      </button>
      {message && <p style={styles.message}>{message}</p>}
    </div>
  );
};

const styles = {
  container: {
    marginTop: '20px',
    padding: '10px',
    backgroundColor: '#F3E9DC', // Default background color
    borderRadius: '5px',
    textAlign: 'center',
  },
  emailInput: {
    padding: '10px',
    fontSize: '16px',
    marginRight: '20px',
    marginBottom: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    width: '250px', // Adjust width for better visibility
  },
  subscribeButton: {
    padding: '10px 20px',
    fontSize: '16px',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: 'var(--green-eucalyptus)', // Keep this one
  },
  message: {
    marginTop: '10px',
    fontSize: '14px',
    color: 'green',
  },
};

export default NewsletterSubscription;